import React from "react";
import {
  FaInstagram,
  FaTiktok,
  FaLinkedinIn,
  FaFacebook,
} from "react-icons/fa";

const SocialLinks = () => {
  return (
    <div className="flex space-x-4 items-center pt-2">
      {/* Instagram Link */}
      <a
        href="https://www.instagram.com/tuutuumab"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaInstagram />
      </a>

      {/* TikTok Link */}
      <a
        href="https://www.tiktok.com/@tuutuumab"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaTiktok />
      </a>

      {/* LinkedIn Link */}
      <a
        href="https://www.linkedin.com/company/tuutuum"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaLinkedinIn />
      </a>

      {/* Facebook Link */}
      <a
        href="https://www.facebook.com/tuutuum"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaFacebook />
      </a>
    </div>
  );
};

export default SocialLinks;
